import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Silence expected, benign WebSocket/HMR connection warnings in AI Studio preview
if (typeof window !== 'undefined') {
  const ignoreBenignWebSocketErrors = (event: ErrorEvent | PromiseRejectionEvent) => {
    const isWSError = 
      (event instanceof ErrorEvent && (
        event.message?.includes('websocket') || 
        event.message?.includes('vite') ||
        event.filename?.includes('vite')
      )) ||
      ('reason' in event && event.reason && (
        String(event.reason).includes('websocket') ||
        String(event.reason?.message).includes('websocket') ||
        String(event.reason?.message).includes('WebSocket') ||
        String(event.reason).includes('WebSocket')
      ));

    if (isWSError) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  window.addEventListener('error', ignoreBenignWebSocketErrors, true);
  window.addEventListener('unhandledrejection', ignoreBenignWebSocketErrors, true);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

